import { render, staticRenderFns } from "./BaseAssetClass.vue?vue&type=template&id=8874ed76&scoped=true"
import script from "./BaseAssetClass.vue?vue&type=script&lang=js"
export * from "./BaseAssetClass.vue?vue&type=script&lang=js"
import style0 from "./BaseAssetClass.vue?vue&type=style&index=0&id=8874ed76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8874ed76",
  null
  
)

export default component.exports